import Icon from '../../../components/AppIcon';

const MetricsSummary = ({ metrics }) => {
  const formatNumber = (num) => {
    return new Intl.NumberFormat('en-US')?.format(num);
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })?.format(amount);
  };

  const metricCards = [
    {
      label: 'Total Tonnage',
      value: `${formatNumber(metrics?.totalTonnage)} MT`,
      icon: 'Package',
      color: 'text-blue-600',
      bgColor: 'bg-blue-100 dark:bg-blue-900/30',
      change: metrics?.tonnageChange,
      changeType: metrics?.tonnageChange >= 0 ? 'increase' : 'decrease'
    },
    {
      label: 'Active Shipments',
      value: formatNumber(metrics?.activeShipments),
      icon: 'Ship',
      color: 'text-green-600',
      bgColor: 'bg-green-100 dark:bg-green-900/30',
      change: metrics?.shipmentsChange,
      changeType: metrics?.shipmentsChange >= 0 ? 'increase' : 'decrease'
    },
    {
      label: 'Gross Fees',
      value: formatCurrency(metrics?.grossFees),
      icon: 'DollarSign',
      color: 'text-purple-600',
      bgColor: 'bg-purple-100 dark:bg-purple-900/30',
      change: metrics?.feesChange,
      changeType: metrics?.feesChange >= 0 ? 'increase' : 'decrease'
    },
    {
      label: 'Open Issues',
      value: formatNumber(metrics?.openIssues),
      icon: 'AlertTriangle',
      color: 'text-orange-600',
      bgColor: 'bg-orange-100 dark:bg-orange-900/30',
      change: metrics?.issuesChange,
      changeType: metrics?.issuesChange <= 0 ? 'increase' : 'decrease'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {metricCards?.map((metric, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-4 hover:shadow-md transition-shadow"
        >
          <div className="flex items-start justify-between mb-3">
            <div className={`w-12 h-12 rounded-lg ${metric?.bgColor} flex items-center justify-center`}>
              <Icon name={metric?.icon} size={24} className={metric?.color} />
            </div>
            {metric?.change !== undefined && (
              <div className={`flex items-center gap-1 px-2 py-1 rounded text-xs font-medium ${
                metric?.changeType === 'increase' ?'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400' :'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400'
              }`}>
                <Icon
                  name={metric?.changeType === 'increase' ? 'TrendingUp' : 'TrendingDown'}
                  size={12}
                />
                <span>{Math.abs(metric?.change)}%</span>
              </div>
            )}
          </div>
          <p className="text-2xl font-bold text-foreground mb-1">{metric?.value}</p>
          <p className="text-sm text-muted-foreground">{metric?.label}</p>
        </div>
      ))}
    </div>
  );
};

export default MetricsSummary;